import { ConciergeBell, QrCode, HandPlatter } from "lucide-react";

const STEPS = [
  { n: "01", icon: ConciergeBell, label: "Pilih menu", sub: "dan tentukan nomor meja" },
  { n: "02", icon: QrCode, label: "Transfer atau QRIS", sub: "staf mengonfirmasi pembayaran" },
  { n: "03", icon: HandPlatter, label: "Diantar ke meja", sub: "duduk santai, kami antar" },
];

export const Steps = () => (
  <section id="cara-pesan" className="wrap -mt-6 sm:-mt-8 relative z-10 scroll-mt-28" data-testid="how-to-order-strip">
    <div className="bg-sage-100 border border-sage-200 rounded-2xl shadow-[0_10px_30px_-18px_rgba(21,94,173,0.35)] grid sm:grid-cols-3 divide-y sm:divide-y-0 sm:divide-x divide-sage-200">
      {STEPS.map(({ n, icon: Icon, label, sub }) => (
        <div key={n} className="flex items-center gap-4 px-6 py-5" data-testid={`step-${n}`}>
          <span className="w-11 h-11 shrink-0 rounded-full bg-forest text-paper grid place-items-center font-semibold">{n}</span>
          <Icon className="w-8 h-8 text-ink shrink-0" strokeWidth={1.4} />
          <div>
            <div className="font-semibold text-ink text-base">{label}</div>
            <div className="text-xs text-muted2">{sub}</div>
          </div>
        </div>
      ))}
    </div>
  </section>
);
